import React from 'react';
import CurrentItemPage from '../../components/Views/CurrentItemPage';
import { getItemSeoData } from '../../utils/helpers';
import Layout from '../../components/Layout/Layout';

const CurrentItem = () => <CurrentItemPage />;
CurrentItem.getInitialProps = async ({ apolloClient, asPath, res, req }) => {
  if (res && !asPath.match(/\d+/)?.[0]) {
    res.statusCode = 404;

    return {
      statusCode: 404
    };
  }

  const seoData = await getItemSeoData(apolloClient, asPath, req);

  return {
    seoData
  };
};

CurrentItem.getLayout = page => (
  <Layout
    isSafeAreaTop={true}
    isBottomNavigation={false}
    isCurrentItemPage={true}
    isShowHeader={false}
    isBanner={false}
  >
    {page}
  </Layout>
);

export default CurrentItem;
